import API_CALL from 'services/API';
import { iPaginationParams } from 'utils/helpers/lists_helpers';
const path = '/user';

export const ServiceUser = {

  profile: async () => {
    return API_CALL({ method: 'GET', url: path + '/profile' });
  },

  list: async (
    paginationParams: iPaginationParams = null,
    fieldsToSearch: any = {},
  ) => {
    return API_CALL({
      method: 'GET',
      url: path + '',
      params: {
        expand: '',
        pagination: true,
        ...paginationParams,
        ...fieldsToSearch,
      },
    });
  },

  changePassword: async ({ id_user, old_password, new_password, repeat_password }) => {
    return API_CALL({
      method: 'POST',
      url: path + '/' + id_user + '/change-password',
      data: {
        old_password,
        new_password,
        repeat_password,
      },
    });
  },

  resetPassword: async ({ email }) => {
    return API_CALL({
      method: 'PUT',
      url: path + '/reset-password',
      data: {
        email: email,
      },
    });
  },

  update: async ({ data, id }) => {

    return API_CALL({
      method: 'PUT',
      url: `${path}/${id}`,
      data,
    });
  },

  delete: async ({ id_user }) => {

    return API_CALL({
      method: 'DELETE',
      url: path + '/' + id_user + '/delete',
    });
  },

  search: (username = '') => {

    if (!username) return [];
    return API_CALL({
      method: 'GET',
      url: path + '',
      params: {
        expand: 'person',
        // Questi controlli vengono fatti poichè username può essere il nome della person, l'id dello user o un array (che arriva dalle pianificazioni) di id user
        name: typeof username === 'string' ? username : null,
        id: Number.isInteger(username) ? username : null,
        idarray: Array.isArray(username) ? username : null
      },
    })
      .then((response) => {
        return response?.data || response;
      })
      .then((users) => {
        //debugger
        return users.map((user) => ({
          key: user.id,
          label: `(${user.username})`,
        }));
      });
  },
};
export default ServiceUser;
